import {AuthStorage} from '@/packages/auth/AuthStorage';
import Cookies from 'js-cookie';
import config from '@/config';

const STORAGE_NAME = config.auth.tokenName;

export default <AuthStorage>{
  get(): string | null | undefined {
    return Cookies.get(STORAGE_NAME);
  },
  save(token: string) {
    Cookies.set(STORAGE_NAME, token, config.cookie);
  },
  remove() {
    Cookies.remove(STORAGE_NAME);
  },
  exists() {
    return !!this.get();
  },
};
